module.exports = __webpack_public_path__ + "img/full3-min.e4357f62.png";